export const workings = {
    "workings_time": "Workings",
    "workings_time_manager_title": "Manager",
    "workings_time_manager_desc": "Go to the management interface",
    "workings_time_fill_in": "Fill in",
    "workings_time_manager_fill_in": "Fill in",
    "workings_time_view": "View",
    // 管理
    "workings_manager_title": "Working Manager",
    "workings_manager_timesheet_label": "Timesheet",
    "workings_manager_timesheet_placeholder": "Select Timesheet",
    "workings_manager_timesheet_opt_all": "All",
    "workings_manager_timesheet_label_StaffName": "Staff Name",
    "workings_manager_export": "Export",
    "workings_manager_table_col_SubmitTime": "SubmitTime",
    "workings_manager_table_col_Timesheet": "Timesheet",
    "workings_manager_table_col_User": "User",
    "workings_manager_table_col_StaffName": "Staff Name",
    "workings_manager_table_col_Option": "Option",
    "workings_manager_table_col_Option_View": "View",
    // 教师界面
    // 加载状态提示
    "workings_loading": "Loading...",
    // 表单字段：选择周期
    "workings_select_period_label": "Select a period",
    "workings_select_period_placeholder": "Please select a time period",
    "workings_select_period_required": "Please select a time period",
    // 分隔标题
    "workings_questions_section_title": "Questions",
    // 提交成功结果页
    "workings_submit_success_title": "Submit successfully！",
    "workings_submit_success_subtitle": "If you have any changes or want to delete, please go to the homepage to modify",
    "workings_return_to_continue_button": "Return to continue filling in other working times",
    // 消息提示（来自 useEffect 中的警告）
    "workings_timesheet_not_started": "The Timesheet is not start",
    "workings_no_auth_access_form": "No auth to access this form",
    "workings_create_success_message": "Successfully created working",
};
